"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Context_1 = require("./Context");
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var IconButton_1 = __importDefault(require("../IconButton"));
var Icon_1 = __importDefault(require("../Icon"));
function SubmitErrorBox(props) {
    var name = props.name;
    var form = (0, Context_1.useFormContext)();
    var submitErrors = form.submitErrors, setSubmitError = form.setSubmitError;
    var error = submitErrors[name];
    return (react_1.default.createElement(react_1.default.Fragment, null, error && (react_1.default.createElement(ErrorBox, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Icon_1.default, { name: 'ff-icon-warning-1', size: 24, mr: '10px' }),
            error),
        react_1.default.createElement(IconButton_1.default, { icon: 'ff-icon-clear', onClick: function () { return setSubmitError(name, ''); } })))));
}
exports.default = SubmitErrorBox;
var ErrorBox = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'rgba(0, 0, 0, 0.5)',
    marginBottom: '8px',
});
